import React from "react";
import Cookies from "js-cookie";
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";
import Icon from "react-icons-kit";
import { ic_remove_red_eye } from "react-icons-kit/md/ic_remove_red_eye";
// import { language } from "react-icons-kit/entypo/language";
import { globe } from "react-icons-kit/fa/globe";
import { eyeBlocked } from "react-icons-kit/icomoon/eyeBlocked";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/scss/components/header/index.scss";
import Logo from "../../assets/images/logo.svg";

import get from "lodash/get";

import CustomButton from "../CustomButton";
import InputText from "../InputText";
import AdminJourneyPage from "../AdminJourneyPage";

const _ = { get };

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      changePasswordToggle: false,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      showOldPassword: true,
      showNewPassword: true,
      showConfirmPassword: true,
      showCountry: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.resetPasswordModelClose !== null &&
      this.props.resetPasswordModelClose !== prevProps.resetPasswordModelClose
    ) {
      let state = this.state;
      state.changePasswordToggle = false;
      state.oldPassword = "";
      state.newPassword = "";
      state.confirmNewPassword = "";
      this.setState({ ...state });
    }
  }

  handleNameChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value.trim();
    this.setState({ ...state });
  };

  handleChangeLanguages = (e) => {
    if (e.target.value !== null) {
      window.localStorage.setItem("lang", e.target.value);
      window.location.reload();
    }
  };

  toggleCountry = () => {
    let state = this.state;
    state.showCountry = !state.showCountry;
    this.setState({ ...state });
  };

  handleToggleIcon = (e, id) => {
    let state = this.state;
    if (id === "1") {
      state.showOldPassword = !state.showOldPassword;
    }
    if (id === "2") {
      state.showNewPassword = !state.showNewPassword;
    }
    if (id === "3") {
      state.showConfirmPassword = !state.showConfirmPassword;
    }
    this.setState({ ...state });
  };

  handleLogout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("RE_BU_CR");
    window.sessionStorage.removeItem("prevFlag");
    window.location.reload();
  };

  handleChangePasswordModelToggle = () => {
    let state = this.state;
    state.changePasswordToggle = !state.changePasswordToggle;
    this.setState({ ...state });
  };

  handleSubmitPasswordChange = (e) => {
    let { elements } = this.props;
    e.preventDefault();
    let state = this.state;
    if (state.newPassword === state.confirmNewPassword) {
      let data = {
        prevPassword: state.oldPassword,
        password: state.newPassword,
      };
      this.props.handleChangePassword(data);
    } else {
      toast.error(
        _.get(
          elements,
          "headerElement.passwordValidationElement",
          "Password Didn't Match"
        )
      );
    }
  };

  render() {
    let { elements } = this.props;

    console.log("zzz", this.props.tourToggle);

    return (
      <header className="header d-flex align-items-center fixed-top">
        <Container fluid>
          <Row>
            <Col sm="12" className="d-flex align-items-center">
              <div className="logo d-flex align-items-center">
                <Button
                  type="button"
                  color="Dark"
                  onClick={this.props.handleToggleIcon}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="11.252"
                    viewBox="0 0 16 11.252"
                  >
                    <g transform="translate(-2 -5)">
                      <path
                        className="toggle-line"
                        d="M2,6a.917.917,0,0,1,.8-1H17.2A.917.917,0,0,1,18,6a.917.917,0,0,1-.8,1H2.8A.917.917,0,0,1,2,6Z"
                        transform="translate(0)"
                      ></path>
                      <path
                        className="toggle-line"
                        d="M2,12.032a.917.917,0,0,1,.8-1H17.2a.917.917,0,0,1,.8,1,.917.917,0,0,1-.8,1H2.8A.917.917,0,0,1,2,12.032Z"
                        transform="translate(0 -1.406)"
                      ></path>
                      <path
                        className="toggle-line"
                        d="M2.8,17.065a1.025,1.025,0,0,0,0,2H17.2a1.025,1.025,0,0,0,0-2Z"
                        transform="translate(0 -2.813)"
                      ></path>
                    </g>
                  </svg>
                </Button>
                <Link to="/">
                  <img src={Logo} alt="" />
                </Link>
                {/* {this.props.location === "/" &&
                  this.props.usertype &&
                  this.props.usertype === "Admin" && (
                    <div class="toggle-btn custom-control custom-switch mt-2">
                      <div>
                        <label class="control-label" for="customSwitch1">
                          Riders Portal
                        </label>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="customSwitch1"
                          checked={this.props.tourToggle}
                          onChange={this.props.handleToggle}
                        />
                        <label class="custom-control-label" for="customSwitch1">
                          TER Portal
                        </label>
                      </div>
                    </div>
                  )} */}
              </div>
              <Nav className="ml-auto flex-row align-items-center" navbar>
                <NavItem className="smooth-dropdown">
                  <ul className="p-0">
                    <li
                      className={`sub-menu-parent ${
                        this.state.showCountry === true ? "show" : ""
                      }`}
                    >
                      {/* <Link onClick={this.toggleCountry}>
                        {" "}
                        <Icon
                          size={18}
                          className="RightIcon inputIcon"
                          icon={globe}
                        />{" "}
                      </Link> */}
                      {/*  */}
                      <div className="sub-menu">
                        {this.props.usertype === "Admin" && (
                          <div className="container">
                            <span className="Icon">
                              <Icon size={25} icon={globe} />
                              <div className="triangle"></div>
                            </span>

                            <select onChange={this.handleChangeLanguages}>
                              {/* <option> Language</option> */}
                              <option value="" disabled selected hidden>
                                {" "}
                              </option>
                              <option value={"default"}>
                                {_.get(
                                  elements,
                                  "headerElement.englishLanguageElement",
                                  "English"
                                )}
                              </option>
                              <option value={"fr"}>
                                {_.get(
                                  elements,
                                  "headerElement.frenchLanguageElement",
                                  "French"
                                )}
                              </option>
                              <option value={"es"}>
                                {_.get(
                                  elements,
                                  "headerElement.spanishLanguageElement",
                                  "Spanish"
                                )}
                              </option>
                              <option value={"it"}>
                                {_.get(
                                  elements,
                                  "headerElement.italianLanguageElement",
                                  "Italian"
                                )}
                              </option>
                              <option value={"de"}>
                                {_.get(
                                  elements,
                                  "headerElement.germanLanguageElement",
                                  "German"
                                )}
                              </option>
                              <option value={"nl"}>
                                {_.get(
                                  elements,
                                  "headerElement.dutchLanguageElement",
                                  "Dutch"
                                )}
                              </option>
                            </select>
                          </div>
                        )}
                      </div>
                    </li>
                  </ul>
                </NavItem>
                <NavItem>
                  <UncontrolledButtonDropdown>
                    <DropdownToggle className="bg-transparent border-0 p-0">
                      <svg
                        id="User_Avatar"
                        data-name="User Avatar"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          id="XMLID_4_"
                          cx="12"
                          cy="12"
                          r="12"
                          fill="#a0a0a0"
                          opacity="0.85"
                        />
                        <path
                          id="Path_19"
                          data-name="Path 19"
                          d="M178.063,238.878c-1.424-.847-4.8-1.683-5.713-2.59a2.243,2.243,0,0,1-.3-2.38,7.994,7.994,0,0,0,.961-2.634h.193c.371,0,.548-1.415.548-2.1a.829.829,0,0,0-.328-.73c-.052-.035-.143-.089-.143-.152v-1.06c0-1.895-.066-2.92-1.148-2.991-.071,0-.058-.052-.083-.118-.239-.643-1.413-1.023-2.438-1.023a3.418,3.418,0,0,0-3.787,3.6v1.594c0,.062-.093.125-.147.156a.777.777,0,0,0-.353.728c0,.683.176,2.1.577,2.1h.193a7.994,7.994,0,0,0,.961,2.634,2.212,2.212,0,0,1-.295,2.385c-.955.924-4.422,1.54-5.763,2.411l.012.021a11.953,11.953,0,0,0,17.051.154Z"
                          transform="translate(-157.659 -218.47)"
                          fill="#fff"
                          opacity="0.35"
                        />
                      </svg>
                    </DropdownToggle>

                    <DropdownMenu>
                      <DropdownItem
                        onClick={this.handleChangePasswordModelToggle}
                      >
                        {_.get(
                          elements,
                          "headerElement.changePasswordDropDown",
                          "Change Password"
                        )}
                      </DropdownItem>
                      <DropdownItem onClick={() => this.handleLogout()}>
                        {_.get(
                          elements,
                          "headerElement.logoutDropdown",
                          "Logout"
                        )}
                      </DropdownItem>
                    </DropdownMenu>
                    <span className="ml-2 user-name text-light align-items-center d-flex text-capitalize">
                      {this.props.userData}
                    </span>
                  </UncontrolledButtonDropdown>
                </NavItem>
              </Nav>
            </Col>
          </Row>

          <Modal isOpen={this.state.changePasswordToggle} centered>
            <Form onSubmit={this.handleSubmitPasswordChange}>
              <React.Fragment>
                <ModalHeader toggle={this.handleChangePasswordModelToggle}>
                  {_.get(
                    elements,
                    "headerElement.headingModelChangePassword",
                    "Change Password"
                  )}
                </ModalHeader>
                <ModalBody className="xyz">
                  <div className="position-relative">
                    <InputText
                      inputType={
                        this.state.showOldPassword ? "password" : "text"
                      }
                      inputName={"oldPassword"}
                      labelName={_.get(
                        elements,
                        "headerElement.oldPasswordLabel",
                        "Old Password"
                      )}
                      InputClass={"mt-2 mt-lg-3 mb-2 inputText"}
                      inputPlaceholder={_.get(
                        elements,
                        "headerElement.oldPasswordPlaceholder",
                        "Old Password"
                      )}
                      customOnChange={(e) => this.handleNameChange(e)}
                      customRequired={true}
                      customValue={this.state.oldPassword}
                    />
                    <Icon
                      size={18}
                      className="RightIcon inputIcon"
                      onClick={(e) => this.handleToggleIcon(e, "1")}
                      icon={
                        this.state.showOldPassword
                          ? eyeBlocked
                          : ic_remove_red_eye
                      }
                    />
                  </div>
                  <div className="position-relative">
                    <InputText
                      inputType={
                        this.state.showNewPassword ? "password" : "text"
                      }
                      inputName={"newPassword"}
                      InputClass={"mt-2 mt-lg-3 mb-2  inputText"}
                      labelName={_.get(
                        elements,
                        "headerElement.newPasswordLabel",
                        "New Password"
                      )}
                      inputPlaceholder={_.get(
                        elements,
                        "headerElement.newPasswordPlaceholder",
                        "New Password"
                      )}
                      customOnChange={(e) => this.handleNameChange(e)}
                      customRequired={true}
                      customValue={this.state.newPassword}
                    />
                    <Icon
                      size={18}
                      className="RightIcon inputIcon"
                      onClick={(e) => this.handleToggleIcon(e, "2")}
                      icon={
                        this.state.showNewPassword
                          ? eyeBlocked
                          : ic_remove_red_eye
                      }
                    />
                  </div>
                  <div className="position-relative">
                    <InputText
                      inputType={
                        this.state.showConfirmPassword ? "password" : "text"
                      }
                      inputName={"confirmNewPassword"}
                      InputClass={"mt-2 mt-lg-3 mb-2  inputText"}
                      inputPlaceholder={_.get(
                        elements,
                        "headerElement.confirmPasswordPlaceholder",
                        "Confirm New Password"
                      )}
                      labelName={_.get(
                        elements,
                        "headerElement.confirmPasswordLabel",
                        "Confirm New Password"
                      )}
                      customOnChange={(e) => this.handleNameChange(e)}
                      customRequired={true}
                      customValue={this.state.confirmNewPassword}
                    />
                    <Icon
                      size={18}
                      className="RightIcon inputIcon"
                      onClick={(e) => this.handleToggleIcon(e, "3")}
                      icon={
                        this.state.showConfirmPassword
                          ? eyeBlocked
                          : ic_remove_red_eye
                      }
                    />
                  </div>
                </ModalBody>
                <ModalFooter>
                  <CustomButton
                    customType={"submit"}
                    name={_.get(
                      elements,
                      "headerElement.submitButtonElement",
                      "Update"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  />
                </ModalFooter>
              </React.Fragment>
            </Form>
          </Modal>
        </Container>
      </header>
    );
  }
}
